<template>
        <img
            ref="imageRef"
            class="image"
            :class="imgClass"
            :src="src"
            :alt="alt"
            :width="(dataWidth) + '%'"
            :height="(dataHeight) + 'px'"
            @error="onError"
        />
</template>

<script>
import _ from "lodash";
import VEmpty from "../Empty/VEmpty.vue";

export default {
    components: { VEmpty },

    name: "vue-image",

    props: {
        src: String,
        alt: String,
        ratio: Number,
        imgClass: String
    },
    data() {
        return {
            dataRatio: this.ratio,
            dataWidth: 100,
            dataHeight: 0,
        };
    },

    methods: {
        /**
         * @description To calculate change height of image to scaling.
         * Do not break the image
         * 
         * @since 2021.12.06
         */
        onScaling() {
            setTimeout(() => {
                try {
                    const imageElement = this.$refs.imageRef;
                    this.dataHeight = `${imageElement.width / this.dataRatio}`;
                } catch(e) {}
            }, 0);
        },

        /**
         * @description Setup data ratio and height
         * 
         * @since 2021.12.06
         */
        onGetRatio() {
           try {
                const imageElement = this.$refs.imageRef;

                if (this.ratio) {
                    this.dataRatio = this.ratio || (imageElement.width / imageElement.height);
                }

                this.dataHeight = `${imageElement.height}`;
           } catch(e) {}
        },

        onError() {
            this.$emit("error");
        }
    },

    mounted() {
        // First time load component
        this.onGetRatio();
        this.onScaling();

        window.addEventListener("resize", _.debounce(this.onScaling, 30));
    },

    destroyed() {
        window.removeEventListener("resize", _.debounce(this.onScaling, 30));
    }
};
</script>

<style lang="scss">
.image {
}
</style>



// WEBPACK FOOTER //
// src/components/Image/VueImage.vue